import { Dialog } from "@headlessui/react"
import React, { Fragment, useState } from "react"
import tw from "twin.macro"
import { useLockScroll } from "@components/utils/LockScroll"
import Transition from "@components/Transition"

const Modal = ({ children, destinationUrl, modalGtmName, triggerContent, triggerStyles, targetModal, screenshotMode, modalTitle, modalPanelStyles, dialogPanelStyles, additionalAction = () => null, tabIndex, }) => {
  let [isOpen, setIsOpen] = useState(false)

  const { addScrollbarCompensation, removeScrollbarCompensation } = useLockScroll()

  const closeModal = () => {
    setIsOpen(false)
    if (!screenshotMode) {
      removeScrollbarCompensation()
    }
  }

  const openModal = () => {
    setIsOpen(true)
    if (!screenshotMode) {
      addScrollbarCompensation()
    }
  }

  const overlayTransitionProps = {
    enter: tw`ease-out duration-300`,
    enterFrom: tw`opacity-0`,
    enterTo: tw`opacity-100`,
    leave: tw`ease-in duration-200`,
    leaveFrom: tw`opacity-100`,
    leaveTo: tw`opacity-0`,
  }

  const childrenWithProps = React.Children.map(children, child => {
    return React.cloneElement(child, {
      closemodal: closeModal,
    })
  })

  return (
    <>
      <button
        onClick={() => {
          openModal();
          additionalAction();
        }} data-gtm={modalGtmName} {...(destinationUrl && { 'data-destination': destinationUrl })} css={[triggerStyles]} data-id={targetModal} tabIndex={tabIndex}>
        {triggerContent}
      </button>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" tw="relative z-50" onClose={closeModal}>
          <Transition.Child as={Fragment} {...overlayTransitionProps}>
            <div tw="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div data-id="modal-panel" css={[tw`fixed inset-0 overflow-y-auto`, modalPanelStyles]}>
            <div tw="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child as={Fragment} {...overlayTransitionProps}>
                <Dialog.Panel css={[tw`w-auto transform overflow-hidden rounded-[24px] bg-tan text-left align-middle shadow-xl transition-all`, dialogPanelStyles,]}>
                  <Dialog.Title tw="sr-only">{modalTitle}</Dialog.Title>
                  {childrenWithProps}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default Modal
